import { render, staticRenderFns } from "./MpAlerts.vue?vue&type=template&id=46958fa8&lang=pug&"
import script from "./MpAlerts.vue?vue&type=script&lang=js&"
export * from "./MpAlerts.vue?vue&type=script&lang=js&"
import style0 from "./MpAlerts.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
